module.exports = function() {
  return new Worker(__webpack_public_path__ + "f9d905e43abbe99b3de5.worker.js");
};